import { createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const backendUrl = process.env.REACT_APP_BACKEND_URL;
// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  choiceGroups: [],
  choiceGroup: null,
  page: 1,
  limit: 10,
  totalPages: 0,
  totalResults: 0,
};

const slice = createSlice({
  name: "choiceGroup",
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      state.error = null;
    },

    startChoiceGroupLoading(state) {
      state.isLoading = true;
      state.error = null;
      state.choiceGroup = null;
    },

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    finishLoading(state) {
      state.isLoading = false;
      state.error = null;
    },

    getChoiceGroupsSuccess(state, action) {
      state.isLoading = false;
      state.choiceGroups = JSON.parse(JSON.stringify(action.payload.results || action.payload || []));
      state.page = action.payload.page || 1;
      state.limit = action.payload.limit || 10;
      state.totalPages = action.payload.totalPages || 0;
      state.totalResults = action.payload.totalResults || 0;
    },

    reRenderGroupsSuccess(state, action) {
      (state.choiceGroup || []).forEach((cg) => {
        if (cg.id === action.payload) {
          cg.selected = true;
        }
      });
    },

    getChoiceGroupSuccess(state, action) {
      state.isLoading = false;
      state.choiceGroup = JSON.parse(JSON.stringify(action.payload.result || action.payload));
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
// export const {
// } = slice.actions;

// ----------------------------------------------------------------------

export function getChoiceGroups(levelId, venueId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`${backendUrl}/choiceGroups?levelId=${levelId}&venueId=${venueId}&limit=100000`);
      dispatch(slice.actions.getChoiceGroupsSuccess(response.data.results));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function reRenderChoiceGroups(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      dispatch(slice.actions.reRenderGroupsSuccess(id));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getChoiceGroup(choiceGroupId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`${backendUrl}/choiceGroups/${choiceGroupId}`);
      dispatch(slice.actions.getChoiceGroupSuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
